declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, GuardianInfoRequest, SaveGuardianInfoRequest, SavePatientInfoRequest } from '../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../models/actor/actor';
import { ActorService } from '../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../models/master/mastermodel';
import { FDService } from '../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ngbaddnewpatient',
  templateUrl: './addnewpatient.modal.html',
  styleUrls: ['./addnewpatient.modal.scss']
})

export class NgbAddNewPatient implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() CurrentActorEditGuardianInfoRequest: SaveGuardianInfoRequest;
  @Input() ServiceCode: number;
  @Input() ActorCode: number;
  searchTitle: string;
    DateOfBirth: NgbDateStruct;
  public isvisible: boolean = true;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  WeddingAn: NgbDateStruct;
  DateOfBirthFemale: NgbDateStruct;
  DateOfBirthMale: NgbDateStruct;
  FemaleDateofBirth: NgbDateStruct;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public Individual: boolean = false;
  public Donor: boolean = false;
  public Couple: boolean = false;
  public Aadhaar: boolean = false;
  public ABDM: boolean = false;
  public Categories: boolean = true;
  public AadhaarNumber: string = '';
  public ABHANumber: string = '';
  //public LoginCountry: string;
  //public LoginState: string;
  //public LoginCity: string;
  CurrentSavePatientInfoRequest: SavePatientInfoRequest;
  //CurrentActorEditGuardainInfoRequest: GuardianInfoRequest;
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService, private spinner: NgxSpinnerService) { }
  ngOnInit() {

    this.ShowService = false;
    this.CurrentSavePatientInfoRequest = new SavePatientInfoRequest();
    this.CurrentSavePatientInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadRegistries();

  }

  individual1() {
    this.ShowService = true;
    this.Categories = false;
    this.Individual = true;
    this.Donor = false;
    this.Couple = false;
    this.Aadhaar = false;
    this.ABDM = false;
  }
  donor() {
    this.ShowService = true;
    this.Categories = false;
    this.Individual = false;
    this.Donor = true;
    this.Couple = false;
    this.Aadhaar = false;
    this.ABDM = false;
  }
  couple() {
    this.ShowService = true;
    this.Individual = false;
    this.Categories = false;
    this.Donor = false;
    this.Couple = true;
    this.Aadhaar = false;
    this.ABDM = false;
  }
  aadhaar() {
    this.ShowService = true;
    this.Individual = false;
    this.Categories = false;
    this.Donor = false;
    this.Couple = false;
    this.Aadhaar = true;
    this.ABDM = false;
  }
  abdm() {
    this.ShowService = true;
    this.Individual = false;
    this.Categories = false;
    this.Donor = false;
    this.Couple = false;
    this.Aadhaar = false;
    this.ABDM = true;
  }
  backtolist() {
    this.ShowService = true;
    this.Categories = true;
    this.Individual = false;
    this.Donor = false;
    this.Couple = false;
    this.Aadhaar = false;
    this.ABDM = false;
  }

  //BranchMapData: ServiceBranchMapByServiceCodeController[];
  //BranchMapRequest: ServiceBranchMapByServiceCodeRequest;
  //this.pdata = this.CurrentCustomCodeValuesController;
  LoadRegistries() {
    this.stopRefreshing();
  }

  onSubmit() {
    this.spinner.show();
    const userDetails = AppData.Instance().UserLoginDetails || {} as any;
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 10;
    if (this.DateOfBirth) {
      this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DateOfBirth));
    }
    this.CurrentSavePatientInfoRequest.CreatedUser = userDetails.EmployeeCode || userDetails.UserName || 'admin';
    this.CurrentSavePatientInfoRequest.ActorType = 3;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = userDetails.EmpFacilityCode || AppData.Instance().SelectedBranchCode || 1;
    this.CurrentSavePatientInfoRequest.UserName = userDetails.UserName || 'admin';
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    //this.CurrentSavePatientInfoRequest.County = AppData.Instance().cas.LoginCountry;
    //this.CurrentSavePatientInfoRequest.State = AppData.Instance().cas.LoginState;
    //this.CurrentSavePatientInfoRequest.City = AppData.Instance().cas.LoginCity;

    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          const res = this.ApiResData.Result;
          const isSuccess = (typeof res === 'number' && res > 0) || 
                            this.ApiResData.Remarks === "Success" || 
                            (Array.isArray(res) && res.length > 0) || 
                            (res && typeof res === 'object');
          if (isSuccess) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.isvisible = false;
            this.spinner.hide();
            this.activeModal.close();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
        else {
            this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
              this.activeModal.close();
              this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
              this.activeModal.close();
              this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }


  onDonor() {
    this.spinner.show();
    this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DateOfBirth));
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 10;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorType = 11;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          const res = this.ApiResData.Result;
          const isSuccess = (typeof res === 'number' && res > 0) || 
                            this.ApiResData.Remarks === "Success" || 
                            (Array.isArray(res) && res.length > 0) || 
                            (res && typeof res === 'object');
          if (isSuccess) {
            this.spinner.hide();
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.isvisible = false;
            this.activeModal.close();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  onCouple() {
    this.spinner.show();
    this.CurrentSavePatientInfoRequest.WeddingAnniversary = new Date(this.parserFormatter.format(this.WeddingAn));
    this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DateOfBirth));
    this.CurrentSavePatientInfoRequest.FemaleDateofBirth = new Date(this.parserFormatter.format(this.FemaleDateofBirth));
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 30;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorType = 3;
    this.CurrentSavePatientInfoRequest.ActorCode = 0;
    this.CurrentSavePatientInfoRequest.AddressCode = 0;
    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          const res = this.ApiResData.Result;
          const isSuccess = (typeof res === 'number' && res > 0) || 
                            this.ApiResData.Remarks === "Success" || 
                            (Array.isArray(res) && res.length > 0) || 
                            (res && typeof res === 'object');
          if (isSuccess) {
            this.spinner.hide();
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.isvisible = false;
            this.activeModal.close();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  CountryName: string;
  Country(event: any) {

    if (event != null) {
      this.CountryName = event;
      //alert(this.CountryName);
    }

  }




}
